import React, { Component } from "react";
import { Link } from "react-router-dom";
import { render } from "react-dom";
import Header from "./header";
import "./homePage.css";
import Slider from "react-slick";
import Footer from "./footer";
import Articles from "../articles/articles";
import {
  Responsive,
  Container,
  Grid,
  Image,
  Pagination,
} from "semantic-ui-react";
import SliderItem from "./slideritem";
import FacebookProvider, { Page } from "react-facebook";
import YouTube from "react-youtube";

import qs from "query-string";
import Parser from "html-react-parser";
import Blog from "../articles/data/blog.json";

import TreeView from "react-treeview";
import moment from "moment";

import Calendar from "react-calendar";
import BlogCard from "../articles/blogcard";
import axios from "axios";
import "react-treeview/react-treeview.css";
import Config from "../../config";

import imgRotaryInt1 from "./img/rotary_international/rotary_international_1.jpg";
import imgRotaryInt2 from "./img/rotary_international/rotary_international_2.jpg";

const format = "YYYY-MM-DD HH:mm";
const now = moment();

const ROOT_URL = Config.ROOT_URL;
class Homepage extends Component {
  state = {
    blogPaginationData: undefined,
    blog: [],
    groups: [],
    groupsDataFromApi: [],
    date: new Date(),
    byDate: [],
    byView: [],
    dataSource: [],
    eventDate: [],
  };
  onChange = (date) => this.setState({ date });
  onClickDay = (date) => {
    var dateStr =
      date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();

    window.location.href = "/events/?d=" + dateStr;
  };
  onLoadGroups = () => {
    axios.get(`${ROOT_URL}/groups`).then((res) => {
      const results = res.data;
      this.setState({
        groupsDataFromApi: results,
      });
    });
  };
  onLoadBlogs = () => {
    axios.get(`${ROOT_URL}/blog`).then((res) => {
      const results = res.data;
      console.log("blog result", results);

      if (results.length > 0) {
        var byDate = results.slice();
        if (byDate.length > 1)
          byDate.sort(function(a, b) {
            return moment(b.date, format) - moment(a.date, format);
          });
        var byView = results.slice().filter((item) => {
          return moment(item.date).isAfter("2018-07-01");
        });
        if (byView.length > 1)
          byView.sort(function(a, b) {
            return b.view > a.view ? 1 : -1;
          });
        console.log("blog by date", byDate);
        console.log("blog by view", byView);

        // var dataSource = [];

        // var years=[];
        // for (var i=0;i<byDate.length;i++){
        //   if (byDate[i].showOnBlog){
        //   var year = moment(byDate[i].date,format).format('YYYY');

        //   var months = [];
        //   if (!years.includes(year)){
        //     years.push(year);

        //     var months=[];
        //     for (var j=0;j<byDate.length;j++){
        //       if (byDate[j].showOnBlog){
        //         var month = moment(byDate[j].date,format).format('MMMM');
        //         if (moment(byDate[j].date,format).format('YYYY')===year){
        //           if (!months.includes(month)){
        //             months.push(month);
        //           }
        //         }
        //       }
        //     }

        //     var blogs=[];
        //     var month_arr = [];
        //     for (var n=0;n<months.length;n++){
        //       for (var k=0;k<byDate.length;k++){
        //         if (byDate[k].showOnBlog){
        //           var month = moment(byDate[k].date,format).format('MMMM');
        //           if (moment(byDate[k].date,format).format('YYYY')===year){
        //             if (moment(byDate[k].date,format).format('MMMM')===months[n]){
        //               blogs.push(byDate[k]);
        //             }
        //           }
        //         }
        //       }
        //       var month_obj = {
        //         type:months[n],
        //         collasped: false,
        //         blogs:blogs
        //       };
        //       month_arr.push(month_obj);
        //     }
        //     var object = {
        //       type: year,
        //       collasped: false,
        //       months: month_arr
        //     };
        //     dataSource.push(object);
        //   }
        //   }

        // }

        let tempDataSource = {};

        byDate.forEach((item) => {
          // get the year data and save to tempDataSource
          var year = moment(item.date, format).format("YYYY");
          var month = moment(item.date, format).format("MMMM");
          var monthInNumber = moment(item.date, format).format("MM");
          // console.log('fff', year, month, monthInNumber)

          if (!tempDataSource[year]) {
            // initial year if no that year
            tempDataSource[year] = {
              type: year,
              collasped: true,
              months: {},
            };
          }

          if (!tempDataSource[year].months[monthInNumber]) {
            // initial that month array if no that month
            tempDataSource[year].months[monthInNumber] = {
              type: month,
              collasped: true,
              blogs: [],
            };
          }
          // push the data into the month
          tempDataSource[year].months[monthInNumber].blogs.push(item);
        });
        console.log("temp", tempDataSource);
        // convert object type to array
        let dataSource = Object.values(tempDataSource)
          .map((item) => {
            item.months = Object.values(item.months);
            return item;
          })
          .sort((item, item2) => {
            return item.type < item2.type ? 1 : -1;
          });
        console.log("ach", dataSource);

        let tempGroups = {};
        results.forEach((blog, i) => {
          if (Array.isArray(blog.groups) && blog.groups.length > 0) {
            blog.groups.forEach((group, j) => {
              tempGroups[group] = group;
            });
          }
        });

        let groups = Object.values(tempGroups);
        byView = byView.splice(0, 10);
        // console.log(byDate);
        // console.log(byView);
        // console.log(dataSource);
        this.setState(
          {
            blog: results,
            byDate: byDate,
            byView: byView,
            dataSource: dataSource,
            groups: groups,
          },
          () => {
            console.log("check", this.state);
          }
        );
      } else {
        console.log(res.data);

        this.setState({
          error: res.data.message,
        });
      }
    });
  };

  onLoadBlogListData = (page = 1) => {
    let url = `${ROOT_URL}/blogs?page=${page}`;
    console.log(this.props.match);
    let group = this.props.match.params.group;
    if (group) {
      url += `&group=${group}`;
    }
    axios.get(url).then((res) => {
      console.log("blog pagination res", res.data);
      this.setState({
        blogPaginationData: res.data,
      });
    });
  };

  onLoadEvents = () => {
    axios.get(`${ROOT_URL}/event/`).then((res) => {
      const results = res.data;
      console.log(results);

      if (results.length > 0) {
        var eventDate = [];
        results.map((e, i) => {
          eventDate.push(e.date);
        });

        this.setState({
          events: results,
          eventDate: eventDate,
        });
      } else {
        console.log(res.data);

        this.setState({
          error: res.data.message,
        });
      }
    });
  };

  normalizedData = (data) => {
    if(!data) return data;
    return data.sort(function(a,b){
      return new Date(b.date) - new Date(a.date);
    });
  };

  componentDidMount() {
    this.onLoadEvents();
    this.onLoadBlogs();
    this.onLoadBlogListData();
    this.onLoadGroups();
  }

  groupButtonOnClick = () => {
    this.onLoadBlogListData();
  };

  render() {
    const { blog, byView } = this.state;
    var settings = {
      dots: true,
      infinite: true,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: false,
      focusOnSelect: true,
      initialSlide: 0,
      arrows: true,
      autoplay: true,
      speed: 500,
      autoplaySpeed: 2000,
      fade: true,
      cssEase: "linear",
      adaptiveHeight: true,
    };
    const opts = {
      width: "260",
      height: "146",
      playerVars: {
        // https://developers.google.com/youtube/player_parameters
        autoplay: 1,
      },
    };

    function _onReady(event) {
      // access to player in all event handlers via event.target
      event.target.pauseVideo();
    }

    const sliderBlogs = Array.isArray(blog) ? blog.slice(0, 6) : [];
    const popularPosts = Array.isArray(byView) ? byView.splice(0, 5) : [];

    return (
      <div className="Homepage">
        <Header page="home" />

        <div className="homeContentWhite">
          <div className="sliderSection">
            <Slider {...settings}>
              {sliderBlogs.map((obj, i) => {
                // if (obj.shownOnHomepage === 1)
                return <SliderItem key={i} blog={obj} />;
              })}
            </Slider>
          </div>
          <div className="homeInfo">
            <div className="homeInfoBoxes">
              <div className="homeInfoBoxContainer">
                <div className="homeInfoBox">
                  <div className="homeInfoBoxInner">
                    <h3 className="homeInfoBoxTitle">Club Meeting</h3>
                    <p className="homeInfoBoxDesc">
                      Lingnan Club (嶺南會所)
                      <br />
                      <br />
                      12-13/F, On Lok Yuen Buildling, 25-27A Des Vouex Road,
                      Central
                      <br />
                      Wednesday 7:30pm
                    </p>
                  </div>
                </div>
                <div className="homeInfoBox">
                  <div className="homeInfoBoxInner">
                    <h3 className="homeInfoBoxTitle">Language</h3>
                    <p className="homeInfoBoxDesc">Cantonese and English</p>
                  </div>
                </div>
                <div className="homeInfoBox">
                  <div className="homeInfoBoxInner">
                    <h3 className="homeInfoBoxTitle">Contact Us</h3>
                    <p className="homeInfoBoxDesc">
                      <a href="mailto:info@rccentral.org">info@rccentral.org</a>
                      <br />
                      <br />
                      GPO Box 10448 Hong Kong
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="homeInfoRotaryInt">
              <div className="homeInfoRotaryIntInner">
                <div className="homeInfoRotaryIntMain">
                  <h2 className="homeInfoRotaryIntTitle">
                    About Rotary International
                  </h2>
                  <div className="homeInfoRotaryIntDescs">
                    <p className="homeInfoRotaryIntDesc">
                      Rotary International is an international service
                      organization whose stated purpose is to bring together
                      business and professional leaders in order to provide
                      humanitarian service and to advance goodwill and peace
                      around the world.
                    </p>
                    <p className="homeInfoRotaryIntDesc">
                      It is a non-political and non-sectarian organization open
                      to all people regardless of race, color, creed, religion,
                      gender, or political preference. There are over 46,000
                      member clubs worldwide, and 1.4 million individuals, known
                      as Rotarians, have joined.​
                    </p>
                    <p className="homeInfoRotaryIntDesc">
                      We are the Rotary Club of Central Hong Kong, District
                      3450.
                    </p>
                  </div>
                  <div className="homeInfoRotaryIntControl">
                    <a
                      href="https://www.rotary.org/en"
                      target="_blank"
                      className="homeInfoRotaryIntBtn"
                    >
                      <span>READ MORE</span>
                    </a>
                  </div>
                </div>
                <div className="homeInfoRotaryIntGallery">
                  <img
                    className="homeInfoRotaryIntImg1"
                    src={imgRotaryInt1}
                    alt=""
                  />
                  <img
                    className="homeInfoRotaryIntImg2"
                    src={imgRotaryInt2}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="homeContent">
            <Grid columns="equal">
              <Grid.Row>
                <Grid.Column mobile={16} tablet={12} computer={12}>
                  {this.state.blogPaginationData ? (
                    <div>
                      <Articles
                        blog={this.normalizedData(this.state.blogPaginationData.data)}
                        mode={1}
                      />
                      <Pagination
                        defaultActivePage={1}
                        totalPages={this.state.blogPaginationData.totalPages}
                        onPageChange={(event, paginationData) => {
                          const activePage = paginationData.activePage;
                          this.onLoadBlogListData(activePage);
                        }}
                      />
                    </div>
                  ) : null}
                </Grid.Column>
                <Grid.Column
                  className="monza-widget-area"
                  textAlign="right"
                  mobile={16}
                  tablet={4}
                  computer={4}
                >
                  <div className="sidebarwidgetsarea section">
                    <div className="widget HTML">
                      <h2 className="title">What is Rotary?</h2>
                      <div className="widget-content">
                        <YouTube
                          videoId="jLUpWV8z3ws"
                          opts={opts}
                          onReady={this._onReady}
                        />
                      </div>
                    </div>
                    <div className="widget HTML">
                      <h2 className="title">FACEBOOK</h2>
                      <div className="widget-content">
                        <FacebookProvider appId="651851528497801">
                          <Page
                            href="https://www.facebook.com/hongkongrcc/"
                            tabs="timeline"
                          />
                        </FacebookProvider>
                      </div>
                    </div>
                    <div className="widget HTML">
                      <h2 className="title">RCC CALENDER</h2>
                      <div className="widget-content Calender">
                        <Calendar
                          onChange={this.onChange}
                          onClickDay={this.onClickDay}
                          value={this.state.date}
                          locale="en-GB"
                          showNeighboringMonth={false}
                          showWeekNumbers={false}
                          tileContent={({ date, view }) => {
                            var dateStr =
                              date.getFullYear() +
                              "-" +
                              (date.getMonth() + 1) +
                              "-" +
                              date.getDate();

                            return this.state.eventDate.includes(dateStr) ? (
                              <p className="eventdot">
                                <i className="fas fa-circle"></i>
                              </p>
                            ) : (
                              <p>&nbsp;</p>
                            );
                          }}
                        />
                      </div>
                    </div>
                    <div className="widget PopularPosts">
                      <h2 className="title">POPULAR POSTS</h2>
                      <div className="widget-content popular-posts">
                        <Articles blog={popularPosts} mode={2} />
                      </div>
                    </div>
                    <div className="widget Label">
                      <h2 className="title">GROUPING</h2>
                      <div
                        id="groups"
                        className="widget-content cloud-label-widget-content"
                      >
                        {this.state.groupsDataFromApi
                          ? this.state.groupsDataFromApi.map((group) => {
                              return (
                                <div class="label-size label-size-1">
                                  <a href={`/blogs/group/${group}`} dir="ltr">
                                    {group}
                                  </a>
                                </div>
                              );
                            })
                          : null}
                      </div>
                    </div>
                    <div className="widget BlogSearch">
                      <h2 className="title">SEARCH</h2>
                      <div className="widget-content ">
                        <div id="BlogSearch1_form">
                          <form
                            action=""
                            className="gsc-search-box"
                            target="_top"
                          >
                            <table
                              cellPadding="0"
                              cellSpacing="0"
                              className="gsc-search-box"
                            >
                              <tbody>
                                <tr>
                                  <td className="gsc-input">
                                    <input
                                      autoComplete="off"
                                      className="gsc-input"
                                      name="q"
                                      size="10"
                                      title="search"
                                      type="text"
                                      value=""
                                    />
                                  </td>
                                  <td className="gsc-search-button">
                                    <input
                                      className="gsc-search-button"
                                      title="search"
                                      type="submit"
                                      value="Search"
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </form>
                        </div>
                      </div>
                    </div>
                    <div className="widget BlogArchive">
                      <h2 className="title">BLOG ARCHIVE</h2>
                      <div className="widget-content">
                        <div id="BlogArchive1_ArchiveList">
                          {this.state.dataSource.map((node, i) => {
                            const type = node.type;
                            const label = (
                              <span className="node">
                                {type}
                                <font className="nodecount">
                                  ({node.months.length})
                                </font>
                              </span>
                            );
                            const months = node.months;
                            return (
                              <TreeView
                                key={type + "|" + i}
                                nodeLabel={label}
                                defaultCollapsed={node.collasped}
                              >
                                {months.map((month) => {
                                  const label2 = (
                                    <span className="node">
                                      {month.type}
                                      <font className="nodecount">
                                        ({month.blogs.length})
                                      </font>
                                    </span>
                                  );
                                  return (
                                    <TreeView
                                      key={month.type + "|" + i}
                                      nodeLabel={label2}
                                      defaultCollapsed={month.collasped}
                                    >
                                      {month.blogs.map((blog, i) => {
                                        return (
                                          <BlogCard
                                            key={i}
                                            blog={blog}
                                            mode={0}
                                            onlyTitle={true}
                                          />
                                        );
                                      })}
                                    </TreeView>
                                  );
                                })}
                              </TreeView>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                    <div className="widget HTML">
                      <div className="widget-content"></div>
                    </div>
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Homepage;

/*
 */
